import { render, staticRenderFns } from "./DiscountDialog.vue?vue&type=template&id=a4ac8cc2"
import script from "./DiscountDialog.vue?vue&type=script&lang=js"
export * from "./DiscountDialog.vue?vue&type=script&lang=js"
import style0 from "./DiscountDialog.vue?vue&type=style&index=0&id=a4ac8cc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports